<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<div class="top-threats-wrapper">
  <app-top-n-threats
    [timeInterval]="timeInterval"
    [selectedOrgId]="selectedOrgId$ | async">
  </app-top-n-threats>
</div>
